<script setup lang="ts">
const { telegram: { bot_link } } = useAppConfig();
const { t } = useI18n();

const menuOpen = ref(false);
</script>

<template>
  <nav class="bg-body-secondary border-top position-fixed start-0 end-0 bottom-0 bottom-nav d-flex d-sm-none">
    <NuxtLink
      to="/"
      class="bottom-nav-item text-body"
      :aria-label="t('bottom_nav.home')"
    >
      <i class="cil-home icon icon-xl" />
    </NuxtLink>

    <a
      v-if="bot_link"
      :href="bot_link"
      class="bottom-nav-item text-body"
      :aria-label="t('bottom_nav.telegram')"
    >
      <i class="cib-telegram-plane icon icon-xl" />
    </a>

    <button
      class="bottom-nav-item text-body border-0 bg-transparent"
      :aria-label="t('bottom_nav.menu.title')"
      @click="menuOpen = true"
    >
      <i class="cil-menu icon icon-xl" />
    </button>
  </nav>

  <Teleport to="body">
    <div
      v-if="menuOpen"
      class="bottom-menu-backdrop"
      @click="menuOpen = false"
    />
    <div
      class="bottom-menu bg-body-secondary"
      :class="{ open: menuOpen }"
    >
      <div class="bottom-menu-header border-bottom px-3 py-2 d-flex justify-content-between align-items-center">
        <span class="fw-semibold">{{ t('bottom_nav.menu.title') }}</span>
        <button
          class="btn-close"
          @click="menuOpen = false"
        />
      </div>
      <ul class="list-unstyled m-0">
        <li class="border-bottom">
          <div class="d-flex align-items-center gap-3 w-100 px-3 py-3">
            <i class="cil-globe icon icon-lg" />
            <span>{{ t('bottom_nav.menu.language') }}</span>
            <AppLanguageSwitcher class="ms-auto" />
          </div>
        </li>
      </ul>
    </div>
  </Teleport>
</template>

<style scoped>
.bottom-nav {
  height: 3.8rem;
  z-index: 1040;
}

.bottom-nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: var(--bs-secondary-color);
  text-decoration: none;
  transition: color 0.15s;
}

.bottom-menu-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1045;
}

.bottom-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  border-radius: 1rem 1rem 0 0;
  transform: translateY(100%);
  transition: transform 0.3s ease;

  &.open {
    transform: translateY(0);
  }
}

.bottom-menu-header {
  height: 3rem;
}
</style>
